// GalleryLabelPersonModal.jsx
import React, { useEffect, useState } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { useLanguage } from '../../../../LanguageProvider';
import './GalleryLabelPersonModal.css';
import LabelPersonTable from './Views/LabelPersonTable';
import Services from '../../../../services/Services';

export default function GalleryLabelPersonModal({
    isOpen,
    onClose,
    activeChannel,
    getCollectionDetail,
    selectedFile
}) {
    const token = localStorage.getItem('token');
    const { getTranslation } = useLanguage();
    const [users, setUsers] = useState([]);

    // userID → labelID eşlemesi
    const labelledMap = (selectedFile?.labelledUsers || []).reduce(
        (map, l) => ({ ...map, [l.userID]: l.labelID }),
        {}
    );

    const getChannelUsers = () => {
        Services.SocialHiveGetChannelUsers(token, activeChannel.channelID)
            .then(res => {
                if (res.data.status) setUsers(res.data.result);
                else setUsers([]);
            })
            .catch(() => setUsers([]));
    };

    const onLabelUser = (userID) => {
        Services.SocialHiveLabelPerson(
            token,
            activeChannel.channelID,
            userID,
            selectedFile.fileID,
            selectedFile.collectionID
        )
            .then(res => {
                if (res.data.status) {
                    getCollectionDetail();
                }
            })
            .catch(() => {/* hata handling */ });
    };

    const onRemoveLabelUser = (labelID) => {
        Services.SocialHiveRemoveLabelPerson(
            token,
            activeChannel.channelID,
            selectedFile.collectionID,
            selectedFile.fileID,
            labelID
        )
            .then(res => {
                if (res.data.status) {
                    getCollectionDetail();
                }
            })
            .catch(() => {/* hata handling */ });
    }

    useEffect(() => {
        if (isOpen) getChannelUsers();
    }, [isOpen]);

    function getFirstAndLastInitials(sentence) {
        const words = sentence
            .trim()
            .split(/\s+/)
            .filter(w => w.length > 0);
        if (words.length === 0) return '';
        const firstInitial = words[0][0];
        const lastInitial = words[words.length - 1][0];
        return (firstInitial + lastInitial).toUpperCase();
    }

    function getAvatarColor(userName) {
        if (!userName) return 'var(--avatar-color-1)';
        const initials = getFirstAndLastInitials(userName);
        if (!initials) return 'var(--avatar-color-1)';
        // Use a simple hash to consistently map to one of 4 colors
        const hash = initials.charCodeAt(0) + (initials.length > 1 ? initials.charCodeAt(1) : 0);
        const colorIndex = (hash % 4) + 1;
        return `var(--avatar-color-${colorIndex})`;
    }

    if (!isOpen) return null;

    const columns = [
        {
            key: 'userAvatar',
            label: '',
            render: user => (
                user.userAvatar ? (
                    <img
                        src={user.userAvatar}
                        alt={`${user.name} ${user.lastname}`}
                        className="avatar"
                    />
                ) : (
                    <div 
                        className="social-hive-chat__avatar"
                        style={{ backgroundColor: getAvatarColor(`${user.name} ${user.lastname}`) }}
                    >
                        {getFirstAndLastInitials(`${user.name} ${user.lastname}`)}
                    </div>
                )
            )
        },
        { key: 'name', label: '' },
        { key: 'lastname', label: '' },
        {
            key: 'select',
            label: '',
            render: user => {
                const labelID = labelledMap[user.id];
                const isChecked = Boolean(labelID);

                const handleChange = () => {
                    if (isChecked) {
                        onRemoveLabelUser(labelID);
                    } else {
                        onLabelUser(user.id);
                    }
                };

                return (
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleChange}
                    />
                );
            }
        }
    ];

    return (
        <div className="label-user-modal-overlay">
            <div className="label-user-modal-container">
                <IoCloseOutline
                    className="label-user-modal-button close"
                    onClick={onClose}
                />
                <LabelPersonTable
                    columns={columns}
                    data={users}
                />
            </div>
        </div>
    );
}
